document.addEventListener("DOMContentLoaded", () => {
  // 页面导航条点击滚动到对应模块
  $(".reward-nav-item").click(function () {
    $(".reward-nav-item").removeClass("active");
    $(this).addClass("active");
    let goto = $(this).data("goto");
    let header_fix_height = 0;
    if ($(".StickyHeaderWrap").hasClass("header-fix")) {
      header_fix_height = $(".header-fix").height();
    }
    $("html, body").animate({
      scrollTop: $(`.${goto}`).offset().top - header_fix_height + "px",
    });
  });

  // 往下滚动冻结页面导航条在顶部
  if ($(window).width() > 600) {
    let nav_offset_top = $(".reward-nav-div").offset().top;
    $(window).scroll(function () {
      let scroll_top = $(window).scrollTop();
      if (scroll_top > nav_offset_top) {
        $(".reward-nav-div").addClass("fixed");
        $('sticky-header header').hide();
        $(".StickyHeaderWrap").removeClass("header-fix");
      } else {
        $(".reward-nav-div").removeClass("fixed");
        $('sticky-header header').show();
        $(".StickyHeaderWrap").removeClass("header-fix");
      }
    });
  }
});